export default "__VITE_ASSET__DhpP0AYl__"